<template>
  <div class="orders-page">
    <header class="orders-header">
      <button type="button" class="back-btn" @click="handleBack">
        <SvgIcon name="orders-nav-back" :size="12" />
        <span>返回</span>
      </button>
    </header>

    <div class="orders-body">
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ElMessage } from 'element-plus';
  import { useRouter } from 'vue-router';
  import SvgIcon from '@/components/common/icon/SvgIcon.vue';

  const router = useRouter();

  async function handleBack() {
    try {
      await router.push({ name: 'create' });
    } catch {
      ElMessage.error('返回失败，请稍后重试');
    }
  }
</script>

<style scoped>
  .orders-page {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }

  .orders-header {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
  }

  .back-btn {
    width: fit-content;
    height: 36px;
    padding: 0 16px;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border: 1px solid #eff0f7;
    border-radius: 66px;
    background: #ffffff;
    color: #160211;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    cursor: pointer;
    transition:
      border-color 0.15s,
      color 0.15s;
  }

  .back-btn:hover {
    border-color: #d8d9e6;
    color: #6033e1;
  }

  .orders-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 24px 0 40px;
    box-sizing: border-box;
  }

  @media (max-width: 767px) {
    .orders-header {
      gap: 0;
      padding: 17px 16px 0;
    }

    .back-btn {
      display: none;
    }

    .orders-body {
      padding: 8px 16px 15px;
    }
  }
</style>
